import { BooleanField, Datagrid, ReferenceField, TextField } from 'react-admin'

import CTList from '../List'
import { SFMSSearchFilter } from './common'

export const SFMSInvoicesList = (props: any) => {
  return (
    <CTList
      bulkActionButtons={false}
      filters={<SFMSSearchFilter />}
      title="Shipper Loads Invoice Status"
      {...props}
    >
      <Datagrid optimized>
        <TextField source="time_since_dropoff" label="Time Since Drop-off" />
        <TextField source="origin_city" label="Origin City" />
        <TextField source="origin_state" label="Origin State" />
        <TextField source="dest_city" label="Destination City" />
        <TextField source="dest_state" label="Destination State" />
        <TextField source="source" label="Shipper Name" />
        <BooleanField source="is_invoiced" label="Invoiced" />
        <ReferenceField basePath="/loads" record={props.record} source="id" reference="loads" link="show">
          <TextField source="id" label="Load ID" />
        </ReferenceField>
      </Datagrid>
    </CTList>
  )
}
